var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("Pagination", {
                    attrs: { numberOfDots: 5, numberOfVisitedDots: 4 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-wrapper" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.cholesterolvaluesheader
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.screening.cholesterolvaluestext
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _vm._l(_vm.data.misc.cholesterollist, function(c, i) {
                    return _c("div", { key: c, staticClass: "card" }, [
                      _c(
                        "h5",
                        {
                          staticClass: "text-light",
                          attrs: {
                            "data-toggle": "collapse",
                            "data-target": "#card-" + c
                          }
                        },
                        [
                          _vm._v("\n            " + _vm._s(c) + " "),
                          c === "LDL-kolestrol"
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v("*")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "collapse", attrs: { id: "card-" + c } },
                        [
                          _c("div", { staticClass: "input-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cols[i].measurement,
                                  expression: "cols[i].measurement"
                                }
                              ],
                              staticClass: "form-control form-control-lg",
                              attrs: {
                                type: "number",
                                placeholder: "mmol/l",
                                disabled: _vm.noResults
                              },
                              domProps: { value: _vm.cols[i].measurement },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.cols[i],
                                    "measurement",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        ]
                      )
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "btn-group-toggle" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block checkbox-btn",
                        class: _vm.noResults ? "active" : false
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.noResults,
                              expression: "noResults"
                            }
                          ],
                          attrs: { type: "checkbox", autocomplete: "off" },
                          domProps: {
                            value: true,
                            checked: Array.isArray(_vm.noResults)
                              ? _vm._i(_vm.noResults, true) > -1
                              : _vm.noResults
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.noResults,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = true,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.noResults = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.noResults = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.noResults = $$c
                              }
                            }
                          }
                        }),
                        _vm._v("\n            Ej tillgängligt\n          ")
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-lg btn-block",
                      attrs: {
                        disabled: !_vm.colsIncomplete() && !_vm.noResults
                      },
                      on: {
                        click: function($event) {
                          return _vm.verifyCols()
                        }
                      }
                    },
                    [_vm._v("\n          Nästa\n        ")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("small", { staticClass: "pull-left" }, [
                    _vm._v("Tryck nästa för att gå vidare.")
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", { staticClass: "pull-left" }, [
      _c("span", { staticClass: "text-danger font-weight-bold" }, [
        _vm._v("*)")
      ]),
      _vm._v(" Viktigast")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a373286e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a373286e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScreeningCholesterolExt.vue
// module id = null
// module chunks = 